import React from 'react';
import { makeStyles, Select, FormControl, MenuItem, InputLabel } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => {
  return {
    formControl: {
      display: 'block',
    },
    select: {
      width: '100%',
    },
  };
});

export function BnSelectField(props) {
  const styles = useStyles();
  const { margin, optionLabel, optionValue, options, className = '', label, ...defaultProps } = props;
  return (
    <FormControl
      margin={margin}
      className={`${styles.formControl} ${className}`}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        { ...defaultProps }
        className={styles.select}
      >
        {options.map((option, index) =>
          optionLabel && optionValue
            ?
            <MenuItem key={index} value={option[optionValue]}>{option[optionLabel]}</MenuItem>
            :
            <MenuItem key={index} value={option}>{option}</MenuItem>,
        )}
      </Select>
    </FormControl>
  );
}
